<template>
    <v-app id="login">
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-card class="elevation-12 rounded">
                            <v-img src="@/assets/img/login-header.png"></v-img>
                            <v-card-title class="label-sign-in-title pa-6">Sign in to continue</v-card-title>
                            <v-card-text class="px-6">
                                <v-form class="form-data" ref="formData" v-model="formData.status" @submit.prevent="login()">
                                    <v-alert v-if="formData.error" type="error" dense outlined>{{ formData.error }}</v-alert>
                                    <!-- Sample FE validation attribute for future purposes -->
                                    <!-- :rules="[$validate.rules.required]" -->
                                    <label for="email" class="field-label font-weight-medium">Email Address</label>
                                    <v-text-field id="email" class="email-field mt-1" v-model="formData.email" name="email" type="text" placeholder="Enter email address" solo dense required>
                                        <template #append-outer>
                                            <v-btn v-if="!isVerified" solo dense class="verify-button" color="#D1E0FF" @click="checkEmail" :loading="formData.loadingEmail">
                                                <span>Verify</span>
                                            </v-btn>
                                            <v-btn v-else solo dense class="verified-button" color="rgba(37, 205, 142, .12)">
                                                <v-icon left class="icon">mdi-checkbox-marked-circle</v-icon>
                                                <span>Verified</span>
                                            </v-btn>
                                        </template>
                                    </v-text-field>

                                    <label v-if="isVerified" for="password" class="field-label font-weight-medium">Password</label>
                                    <v-text-field v-if="isVerified" id="password" class="mt-1" v-model="formData.password" name="password" type="password" placeholder="Enter password" solo dense required></v-text-field>

                                    <div class="recaptcha-wrapper">
                                        <vue-recaptcha
                                        :sitekey="siteKey"
                                        @verify="onVerify"
                                        @expired="onExpired"
                                        size="normal"
                                        ></vue-recaptcha>
                                    </div>

                                    <v-btn type="submit" block class="btn-login mt-4" :loading="formData.loading" color="primary" :disabled="!passedCaptcha || !isVerified">Log In</v-btn>
                                    <div class="text-forgot-password">
                                        <router-link to="/forgot-password">
                                            <v-icon dense> mdi-lock </v-icon> Forgot your password?
                                        </router-link>
                                    </div>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>

        <v-dialog v-model="showModal" max-width="400px" persistent>
            <v-card
                class="otp py-8 px-6 text-center mx-auto"
                elevation="12"
                max-width="400px"
                width="100%"
                style="color: #425466"
            >
                <v-btn
                    icon
                    @click="showModal = false"
                    class="close-button"
                    elevation="0"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <h3 class="text-h6 mb-4 font-weight-bold" >OTP Verification</h3>

                <div class="text-body-2 mb-4">
                Enter code sent to: <strong>{{ formData.email }}</strong>
                </div>
                <v-alert v-if="formData.errorOtp" type="error" dense outlined class="text-left">{{ formData.errorOtp }}</v-alert>

                <!-- <v-sheet color="surface">
                    <v-otp-input
                        v-model="formData.otp"
                        :type="otpType"
                        variant="solo"
                        :key="otpInputKey"
                        @finish="onChange"
                        @keypress="acceptOnlyNumbers"
                    ></v-otp-input>
                </v-sheet> -->

                <div class="d-flex otp-container my-2">
                    <input
                        v-model="formData.otp"
                        :type="otpType"
                        :maxlength="6"
                        @keypress="acceptOnlyNumbers"
                        placeholder="XXXXXX"
                        class="otp-input"
                    >
                    <v-btn
                        icon
                        color="#425466"
                        @click="toggleOtpVisibility"
                        class="mx-2 mt-2"
                        plain
                    >
                        <v-icon>{{ otpType === 'text' ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                    </v-btn>
                </div>

                <v-btn
                    class="my-4"
                    color="#4C6FFF"
                    solo
                    dense
                    width="70%"
                    :disabled="formData.otp.length !== 6"
                    @click="validateOtp"
                    :loading="formData.loadingVerify"
                >
                    <span class="verify-otp-button">Verify</span>    
                </v-btn>

                <div class="text-caption">
                    <span>No code received?</span>
                    <span v-if="countdown > 0">
                        Resend OTP in <strong>{{ formattedTime }}</strong>
                    </span>
                    <a v-else href="#" @click.prevent="resendOtp" class="ml-1">Resend OTP</a>
                </div>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';

export default {
    name: 'login',
    components: { VueRecaptcha },
    data() {
        return {
            showPassword: false,
            isRemember: false,
            formData: {
                status: false,
                loading: false,
                loadingVerify: false,
                loadingEmail: false,
                error: '',
                errorOtp: '',
                email: '',
                password: '',
                otp: '',
                recaptchaResponse: '',
                prelogin_auth: ''
            },
            errorMessage: '',
            showModal: false,
            isVerified: false,
            passedCaptcha: false,
            otpInputKey: 0,
            countdown: 0,
            userId: '',
            siteKey: process.env.VUE_APP_SITE_KEY,
            otpType: 'password'
        };
    },
    computed: {
        query() {
            return this.$route.query;
        },
        formattedTime() {
            const minutes = String(Math.floor(this.countdown / 60)).padStart(2, '0');
            const seconds = String(this.countdown % 60).padStart(2, '0');
            return `${minutes}:${seconds}`;
        }
    },
    methods: {
        preLogin(isResend) {
            this.formData.loadingEmail = true
            let { email, recaptchaResponse } = this.formData;
            let payload = {
                email
            }
            if (!isResend) {
                payload['g-recaptcha-response'] = recaptchaResponse
            }

            this.$store
                .dispatch('authentication/preLogin', { data: payload })
                .then((response) => {
                    this.userId = response.data.user_id
                    if (this.userId) {
                        this.showModal = true
                    }
                })
                .catch((error) => {
                    this.formData.error = error.response && error.response.data
                        ? (
                            error.response.data.errors && error.response.data.errors.email
                                ? error.response.data.errors.email
                                : error.response.data.message
                        )
                        : error.message || 'Login Error';
                })
                .finally(() => {
                    this.formData.loadingEmail = false
                });
        },
        validateOtp() {
            this.formData.loadingVerify = true
            this.formData.errorOtp = ''
            this.formData.prelogin_auth = ''
            const payload = {
                user_id: this.userId,
                otp: this.formData.otp,
                type: "login"
            }

            this.$store
                .dispatch('authentication/validateOtp', { data: payload })
                .then((response) => {
                    if (response.valid) {
                        this.isVerified = true
                        this.showModal = false
                        this.formData.prelogin_auth = response.prelogin_auth
                    }
                })
                .catch((error) => {
                    // Override validation spiel for required fields
                    this.formData.errorOtp = error.response && error.response.data
                        ? (
                            error.response.data.errors && error.response.data.errors.otp
                                ? error.response.data.errors.otp
                                : error.response.data.message
                        )
                        : error.message || 'OTP is invalid';

                    console.log(error)
                })
                .finally(() => {
                    this.formData.loadingVerify = false
                });
        },
        login() {
            let formStatus = this.$refs.formData.validate();

            if (formStatus && this.formData.status && !this.formData.loading) {
                let { email, password, prelogin_auth } = this.formData;
                this.formData.error = '';
                this.formData.errorOtp = '';
                this.formData.loading = true;

                this.$store
                    .dispatch('authentication/fetchCSRFToken')
                    .then(() => {
                        this.$store
                            .dispatch('authentication/login', { data: { email, password, prelogin_auth } })
                            .then((response) => {
                                let { access_token } = response;
                                if (!this.$cookies.get('token') && access_token) {
                                    this.$cookies.set('token', access_token);
                                    this.$api.setAuthorization(window.atob(access_token)); // Decode token
                                    const config = {
                                        params: { appends: ['role', 'permissions', 'merchant'] }
                                    };
                                    //add this to get userinfo in routerjs
                                    this.$store.dispatch('authentication/fetchUserInfo', { config: config }).then((response) => {
                                        const { role, first_name, last_name, merchant } = response.data;
                                        const userInfoCookie = {
                                            first_name,
                                            last_name,
                                            role
                                        };
                                        if (merchant) userInfoCookie.merchant = { id: merchant.id };
                                        userInfoCookie.isRemember = this.isRemember;
                                        this.$cookies.set('user-info', window.btoa(JSON.stringify(userInfoCookie))); // Encode To Base64
                                        this.redirect();
                                    });
                                }
                            })
                            .catch((error) => {
                                this.formData.loading = false;

                                // Override validation spiel for required fields
                                const isRequired = Object.values(this.errors).find((error) => error.includes('required'));
                                if (error.response.status == 422 && isRequired) {
                                    this.formData.error = 'The email address/password is required.';
                                } else {
                                    this.formData.error = error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message || 'Login Error';
                                }
                            });
                    })
                    .catch(() => {});
            }
        },
        redirect() {
            if (this.query.redirect) {
                this.$router.push({ name: this.query.redirect });
            } else {
                this.$router.push({ name: 'default-layout' });
            }
            this.formData.loading = false;
        },
        validateEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(email);
        },
        checkEmail() {
            this.formData.error = '';
            this.formData.errorOtp = '';

            if (!this.formData.recaptchaResponse) {
                this.formData.error = 'Recaptcha is required.';
            } else if (this.validateEmail(this.formData.email)) {
                if (this.countdown === 0) this.preLogin()
                else this.showModal = true
            } else {
                this.formData.error = 'Please enter a valid email address.';
            }
        },
        onVerify(response) {
            this.passedCaptcha = true
            this.formData.error = ''
            this.formData.recaptchaResponse = response
        },
        onExpired() {
            console.log('reCAPTCHA expired, please try again.');
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset(); // Reset the reCAPTCHA
        },
        resendOtp() {
            this.formData.otp = '';
            this.formData.errorOtp = '';
            this.otpInputKey++;
            this.preLogin(true)
            
            this.countdown = 180; // Set countdown to 3 minutes (180 seconds)

            // Start countdown
            const countdownInterval = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(countdownInterval);
                }
            }, 1000);
        },

        onChange(otp) {
            this.formData.otp = otp
        },

        toggleOtpVisibility() {
            this.otpType = this.otpType === 'password' ? 'text' : 'password'
        },

        acceptOnlyNumbers(event) {
            const keyCode = event.keyCode ? event.keyCode : event.which;
            if (keyCode < 48 || keyCode > 57) { // ASCII codes for 0-9
                event.preventDefault();
            }
        },
    },

    watch: {
        showModal(val) {
        if (!val) {
            this.otpInputKey += 1
            this.formData.otp = ''
            this.formData.loadingVerify = false
            this.userId = ''
        }
        },
    },

    mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#login {
    .check-label-remember-me {
        color: #425466;
    }

    .label-sign-in-title {
        color: #16192c;
        font-weight: bold;
    }

    .v-text-field {
        &.theme--light {
            .v-input__slot {
                background-color: var(--v-secondaryBackgroundColor-base);
            }
        }

        &.theme--dark {
            .v-input__slot {
                background-color: var(--v-secondaryBackgroundColor-base);
            }
        }
    }

    .text {
        margin: 20px 0 0 0;
        text-transform: uppercase;
        font-size: 12px;

        span {
            color: #0984e3;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .text-forgot-password {
        cursor: pointer;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 10px;
        margin-top: 20px;
        text-align: center;

        a {
            color: #425466;
            text-decoration: none;
        }
    }

    .recaptcha-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .email-field {
        border-radius: 6px 0px 0px 6px;
    }

    .verify-button {
        margin-left: -10px;
        margin-top: -5px;
        border-radius: 0px 6px 6px 0px;

        span {
            color: #425466;
        }
    }

    .verified-button {
        margin-left: -10px;
        margin-top: -5px;
        border-radius: 0px 6px 6px 0px;

        .icon {
            color: #25CD8E;
        }

        span {
            color: #25CD8E;
        }
    }

    .otp {
        .text-caption {
            span {
                color: #425466;
            }
        }
    }
}

::v-deep .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: rgba(76, 111, 255, 0.6) !important;
    color: white !important;
}

.close-button {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
}

.verify-otp-button {
    color: #FFFFFF !important;
}

input:focus {
    border: none;
    outline: none;
}

.otp-container {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
}

.otp-input {
    width: 100%;
    padding: 10px;
    text-align: center;
    color: #425466;
    font-size: 20px;
    letter-spacing: 10px;
    padding-left: 52px;
}
</style>
